const initialState = {
    orders: [],
    selectedTab: 'pending',
};
const courierOrders = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_COURIER_ORDERS':
            return {...state, [action.name]: action.value};
       	
        default:
            return state;
    }
};

export default courierOrders;
